import React, { useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ActionButton } from "../../components/controls";
import 'date-fns';
import { Backdrop, Box, Card, CircularProgress, Container, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable, { MTableToolbar } from 'material-table'
import { RoleMasterService } from "../../services";
import TableIcons from '../../materialTableIcons';
import { Magnify} from "mdi-material-ui";
import '../GridStyleOverrides/materialTableHome.css'
import { SET_FORM_DATA_FROM_TABLE_ROLE_MASTER, SET_IS_EDITING_ROLE, SET_IS_CREATING_ROLE, SET_ALL_ROLES } from '../../actions/types';
import allowAction from '../../helpers/allowAction';

//Many of these stylings aren't being used,  Material Table doesn't handle classNames
const useStyles = makeStyles((theme) => ({
    textInput: {
        '& label.Mui-focused': {
            color: theme.palette.text.primary,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#86C1D4',
            },
            '&:hover fieldset': {
                borderColor: theme.palette.text.primary,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.text.primary,
            },
        },
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        marginLeft: 10,
        marginRight: 20,
        paddingRight: 30
    },
    cardFiltersContainer: {
        marginTop: 20,
        backgroundColor: theme.palette.background.paper
    },
    cardContentForFiltersContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        backgroundColor: theme.palette.background.paper
    },
    filterDropdownsContainer: {
        minWidth: '80%',
    },
    gridItem: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
    },
    showAllAndFilterButtonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    showAllButton: {
        width: 140,
        marginBottom: 8,
    },
    filterButton: {
        width: 140,
        marginTop: 8,
    },
    card: {
        display: 'block',
        marginTop: 20,
        marginBottom: 30,
        paddingTop: 20,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: theme.palette.background.paper,
    },
    inputGridContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: 0,
        justifyContent: 'space-between'
    },
    exportButton: {
        width: 140,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    searchButton: {
        width: 180,
        fontWeight: 'bold',
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    inputLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: '1rem',
        marginRight: '1rem',
        color: theme.palette.text.secondary,
        width: '4rem',
        fontSize: 16,
        zIndex: 1000,
        lineHeight: 1.75,
        fontWeight: 'bold',
    },
    textField: {
        width: 220,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    createNewButton: {
        marginLeft: 20,
    },
    tableHeader: {
        backgroundColor: '#86C1D4'
    },
    tankMidnightTable: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 20,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellTitle': {
            fontWeight: 700,
            color: theme.palette.background.paper,
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellSortable': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-columnSeparator': {

        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

//The following objects can be modified here as needed then passed as options to the table:
const headerStyle = {
    backgroundColor: '#86C1D4',
    color: 'white',
    height: 49,
    textTransform: 'uppercase',
}
const rowStyle = {
    maxHeight: 50,
}

export default function RoleMasterHome() {

    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const [isTableLoading, setIsTableLoading] = useState(true);

    const [dataSource, setDataSource] = useState([]);
    const [dataForTable, setDataForTable] = useState([]);
    const [freeSearchValue, setFreeSearchValue] = useState('');

    //APPLY FILTERS/SEARCH
    useEffect(() => {
        let data = [...dataSource];
        if (dataSource) {
            if (freeSearchValue) {
                let query = freeSearchValue.toLowerCase().trim();
                let applySearch = dataSource.filter((item) => {
                    return (
                        item.rolName?.toLowerCase().indexOf(query) >= 0 ||
                        item.rolDescription?.toLowerCase().indexOf(query) >= 0
                    )
                })
                data = applySearch
            }
            setDataForTable([...data])
        }
    }, [dataSource, freeSearchValue])

    useEffect(() => {
        async function fetchRoles() {
            let data = await RoleMasterService.getRoles();
            data.sort((a, b) => a.rolId - b.rolId);
            setDataSource(data);
            setIsTableLoading(false);
        }
        fetchRoles()
    }, []);

    const handleFreeSearchChange = (event) => {
        setFreeSearchValue(event.target.value)
        //string
    };

    const columnDefs = [
        {
            title: '#',
            field: 'custom',
            cellStyle: { width: 100, minWidth: 100, maxWidth: 100, paddingLeft: 50 },
            headerStyle: { paddingLeft: 50 },
            render: rowData => rowData.tableData.id + 1
        },
        {
            title: 'Name',
            field: 'rolName',
            cellStyle: { width: 300, minWidth: 300, maxWidth: 300 }
        },
        {
            title: 'Description',
            field: 'rolDescription',
            cellStyle: { width: 600, minWidth: 300, maxWidth: 600 }
        },

    ]

    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Role Master
                    </h2>
                </div>
                <Card className={classes.card}>
                    <div className={classes.actions}>
                        {allowAction("502", "create") ?
                            <ActionButton text='Create New' className={classes.createNewButton} onClick={() => {

                                //get max + 1 for new role ID
                                let nums = dataSource.map(x => Number(x.rolId))
                                let next = Math.max(...nums) + 1

                                dispatch({
                                    type: SET_IS_CREATING_ROLE,
                                    payload: true,
                                });
                                dispatch({
                                    type: SET_IS_EDITING_ROLE,
                                    payload: false,
                                });
                                dispatch({
                                    type: SET_FORM_DATA_FROM_TABLE_ROLE_MASTER,
                                    payload: {
                                        rolId: "",
                                        rolName: "",
                                        rolDescription: "",
                                        sequence: next,
                                    }
                                })
                                dispatch({
                                    type: SET_ALL_ROLES,
                                    payload: dataSource
                                })
                                history.push('/admin/role-master/manage')
                            }
                            } />
                            : null}
                        <TextField
                            id="search"
                            name="search"
                            variant='outlined'
                            size='small'
                            style={{width: '40rem', marginLeft: 30}}
                            label='Type to filter results...'
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton disabled={true}>
                                            <Magnify />
                                        </IconButton>
                                    </InputAdornment>
                            }}
                            disabled={dataSource?.length === 0}
                            value={freeSearchValue}
                            onChange={(event) => {
                                handleFreeSearchChange(event);
                            }}
                        />
                    </div>
                    <Box px={1.5} className={classes.tankMidnightTable}>
                        <MaterialTable
                            style={{ width: '100%', boxShadow: 'none' }}
                            //tableRef={tableRef}
                            icons={TableIcons}
                            columns={columnDefs}
                            data={dataForTable}
                            title=""
                            //hide the default toolbar
                            components={{
                                Toolbar: props => (
                                    <div style={{ width: 0, height: 0 }}>
                                        <MTableToolbar {...props} />
                                    </div>
                                ),
                            }}
                            localization={{
                                header: {
                                    actions: 'Manage'
                                }
                            }}
                            options={{
                                actionsCellStyle: { paddingLeft: 40, paddingRight: 60, width: 100, justifyContent: 'center', textAlign: 'center'},
                                actionsColumnIndex: -1,
                                filtering: false,
                                search: false,
                                sorting: true,
                                headerStyle: headerStyle,
                                rowStyle: rowStyle,
                                maxBodyHeight: '600px',
                                showTitle: false,
                                toolbar: false,
                                paging: true,
                                pageSize: 10,
                                emptyRowsWhenPaging: true,
                                pageSizeOptions: [10, 20, 50],
                                
                            }}
                            actions={[
                                {
                                    icon: () => <TableIcons.Edit/>,
                                    tooltip: 'Edit Role',
                                    disabled: allowAction("502", "edit") ? false : true,
                                    onClick: (event, rowData) => {
                                        dispatch({
                                            type: SET_FORM_DATA_FROM_TABLE_ROLE_MASTER,
                                            payload: { ...rowData },
                                        });
                                        dispatch({
                                            type: SET_IS_CREATING_ROLE,
                                            payload: false,
                                        });
                                        dispatch({
                                            type: SET_IS_EDITING_ROLE,
                                            payload: true,
                                        });
                                        dispatch({
                                            type: SET_ALL_ROLES,
                                            payload: dataSource
                                        })
                                        history.push('/admin/role-master/manage')
                                    }
                                }
                            ]}
                        />
                    </Box>
                </Card>
            </Container >
            <Backdrop className={classes.backdrop} open={isTableLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}